import { LocationVariant } from "../../components/Location/components/Location/types.js";
const ADDRESS_CONFIGURATION_SIZES = [
  "MINIMAL",
  "SMALL",
  "MEDIUM",
  "LARGE",
  "COMPLETE"
];
const OPENING_HOURS_DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];
var OpenClosedStatus = /* @__PURE__ */ ((OpenClosedStatus2) => {
  OpenClosedStatus2["Open"] = "OPEN";
  OpenClosedStatus2["Closing"] = "CLOSING";
  OpenClosedStatus2["Closed"] = "CLOSED";
  return OpenClosedStatus2;
})(OpenClosedStatus || {});
export {
  ADDRESS_CONFIGURATION_SIZES,
  LocationVariant,
  OPENING_HOURS_DAYS,
  OpenClosedStatus
};
//# sourceMappingURL=index.js.map
